import { getTestAttributes } from '@chillibean/component-library';
import { PropTypes } from 'prop-types';

function HeroBoxHeaderTitle(props) {
  const { title = '', subTitle = '' } = props;

  return (
    <div>
      <span className="hero-box__header-title">{title}</span>
      <span className="hero-box__header-subtitle" {...getTestAttributes('hero-box-subtitle')}>
        {subTitle}
      </span>
    </div>
  );
}

HeroBoxHeaderTitle.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
};

export default HeroBoxHeaderTitle;
